import { request } from './index';
const syncUrls = {
	getProjectsFromClients: (clientId: string) => `/sync/from/client/${clientId}/project`,
	getTmpAccountsFromClients: (clientId: string) => `/sync/from/client/${clientId}/account/tmp`,
	sendOfficialToClient: (clientId: string) => `/sync/to/client/${clientId}/account/officail`,
};

// 从分端同步项目
export const getProjectsFromClients = (clientId: string): Promise<void> => {
	return new Promise((resolve) => {
		request(syncUrls.getProjectsFromClients(clientId), undefined, 'get').then((res) => {
			resolve();
		});
	});
};

// 从分端同步待添加成员
export const getTmpAccountFromClients = (clientId: string): Promise<void> => {
	return new Promise((resolve) => {
		request(syncUrls.getTmpAccountsFromClients(clientId), undefined, 'get').then((res) => {
			resolve();
		});
	});
};

// 向分端同步标准库成员
export const sendOfficialToClient = (clientId: string): Promise<void> => {
	return new Promise((resolve) => {
		request(syncUrls.sendOfficialToClient(clientId), undefined, 'get').then((res) => {
			resolve();
		});
	});
};
